import React from 'react';
import { Typography, styled, Button } from '@nextiva/next-ui-components';
import styles from '../../containers/pages/NotFound/NotFound.scss';

const StyledTypography = styled(Typography)`
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 2.125rem;
  margin-bottom: 6px;
`;
const StyledSubTitleTypography = styled(Typography)`
  font-weight: 400;
  line-height: 1.3125rem;
`;

const StyledContentTypography = styled(Typography)`
  font-weight: 400;
  margin: 32px 0 22px 0;
`;
const StyledButton = styled(Button)`
  font-size: 0.875rem;
  align-self: center;
  width: 78px;
  height: 30px;
  &.MuiButton-containedPrimary {
    padding: 0 10px;
  }
`;
const StyledContainer = styled('div')`
  display: flex;
  justify-content: center;
  color: #333333;
  flex-direction: column;
  text-align: center;
`;

export const SimplePlaceHolder = ({ title, content, subTitle, image, alt }) => {
  return (
    <StyledContainer>
      <StyledTypography>{title}</StyledTypography>
      <StyledSubTitleTypography
        variant="subtitle1"
        dangerouslySetInnerHTML={{ __html: subTitle }}
      />

      <img src={image} alt={alt} className={styles.image} />
      <StyledContentTypography variant="subtitle1">
        {content}
      </StyledContentTypography>
      <StyledButton
        color="primary"
        onClick={() => window.history.back()}
        size="small"
        variant="contained"
        data-testid="PlatformAdminUI-NotFound-Button"
      >
        Go Back
      </StyledButton>
    </StyledContainer>
  );
};
